import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'playbook-media',
    title: 'Playbook Media',
    description: 'Analytics platform for Real Estate Agents.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
    },
};

export default data;
